// startup
// Load entry module and return exports
// This entry module depends on other loaded chunks and execution need to be delayed
var __webpack_exports__ = __webpack_require__.O(undefined, ["library/common","library/swiper","library/splidejs"], () => (__webpack_require__("./sources/js/modules/image-carousel-stats.js")))
__webpack_exports__ = __webpack_require__.O(__webpack_exports__);
